import React from "react";
import CustomModal from "Components/CommonComponents/CustomModal";
import VideoPlayer from "Pages/AssetView/VideoPlayer";
import PDFPageviewer from "Pages/PlannerView/PDFPageviewer";
import ErrorView from "Pages/AssetView/ErrorView";

interface AssetViewerModalProps {
  isOpen: boolean;
  onClose: () => void;
  contentType: {
    type: "video" | "ebook" | null;
    data: string;
  } | null;
  pdfPassword?: string | null;
  title?: string;
  assetId?: string;
}

const AssetViewerModal: React.FC<AssetViewerModalProps> = ({
  isOpen,
  onClose,
  contentType,
  pdfPassword,
  title,
  assetId,
}) => {
  console.log("contentType", contentType);
  return (
    <CustomModal
      modal={isOpen}
      centered={true}
      backdrop={true}
      size={contentType?.type === "video" ? "lg" : "xl"}
      fullscreen={true}
      title={title || " "}
      toggle={onClose}
    >
      <div className="w-100 d-flex p-3 align-items-center justify-content-center">
        {contentType && contentType != null ? (
          contentType.type === "video" ? (
            <VideoPlayer
              videoUrl={contentType.data}
              JWTToken={""}
              assetId={assetId}
              source={"FEX"}
            />
          ) : contentType?.data !== "" && pdfPassword != null ? (
            <PDFPageviewer
              allPageInOne={true}
              pdfUrl={contentType?.data}
              pdfPassword={pdfPassword}
              isLibraryView={true}
            />
          ) : (
            <ErrorView />
          )
        ) : null}
      </div>
    </CustomModal>
  );
};

export default AssetViewerModal;
